import React from "react";

const MyContext = React.createContext();
MyContext.displayName = "methodExecute";
export default MyContext;
